<template>
    <div>
        <span class="page-span" v-if="currentPageSpan"
            >{{ currentPageSpan[0] }}-{{ currentPageSpan[1] }}
            of
        </span>
        <span class="results-text">
            {{ totalResults }} total result<span v-if="totalResults !== 1"
                >s</span
            >
        </span>
    </div>
</template>

<script>
export default {
    name: "GridControlsCount",
    props: {
        currentPage: {
            type: Number,
            default: 1
        },
        perPage: {
            type: Number,
            default: 10
        },
        totalResults: {
            type: Number,
            default: 0
        }
    },
    computed: {
        currentPageSpan() {
            if (this.totalResults <= 1) return null;

            var x = 1;
            var y = this.totalResults;

            if (this.perPage < this.totalResults) {
                x = this.currentPage * this.perPage - this.perPage + 1;

                if (this.currentPage <= this.totalResults / this.perPage) {
                    y = this.currentPage * this.perPage;
                }
            }

            return [x, y];
        }
    }
};
</script>
